import { HttpService } from "./httpService";
import { CreateBannerRequest, UpdateBannerRequest } from "../types/banner";

export class storeService {
    
    static getStore = async () => {
        try {
            return await HttpService.get('/store');
        } catch (error: any) {
            // 404 means the seller hasn't created a store yet — return null so
            // the caller can redirect to onboarding instead of treating it as an error.
            if (error?.response?.status === 404) {
                return null;
            }
            console.error('Error fetching store:', error);
            throw new Error('Failed to fetch store configuration. Please try again.');
        }
    }

    static createStore = async (store: {brandName:string,url:string}) => {
        try {
            return await HttpService.post('/store', store);
        } catch (error: any) {
            console.error('Error creating store:', error);
            if (error?.response?.status === 409) {
                throw new Error(error?.response?.data?.message || 'Store already exists with this configuration.');
            }
            if (error?.response?.status === 400) {
                throw new Error('Invalid store configuration. Please check your input.');
            }
            throw new Error('Failed to create store. Please try again.');
        }
    }

    static updateStore = async (store: any) => {
        try {
            return await HttpService.patch('/store', store);
        } catch (error: any) {
            console.error('Error updating store:', error);
            if (error?.response?.status === 400) {
                throw new Error('Invalid store data. Please check your input.');
            }
            if (error?.response?.status === 404) {
                throw new Error('Store not found. Please create a store first.');
            }
            throw new Error('Failed to update store configuration. Please try again.');
        }
    }

    static toggleBanner = async (bannerId: string) => {
        try {
            return await HttpService.patch(`/store/banners/${bannerId}/toggle`, {});
        } catch (error: any) {
            console.error('Error toggling banner:', error);
            if (error?.response?.status === 404) {
                throw new Error('Banner not found. It may have been deleted.');
            }
            if (error?.response?.status === 403) {
                throw new Error('You don\'t have permission to modify this banner.');
            }
            if (error?.response?.status === 400) {
                throw new Error('Invalid banner operation. Please try again.');
            }
            throw new Error('Failed to update banner status. Please try again.');
        }
    }

    static addBanner = async (banner: CreateBannerRequest) => {
        try {
            return await HttpService.post('/store/banners', banner);
        } catch (error: any) {
            console.error('Error adding banner:', error);
            if (error?.response?.status === 400) {
                throw new Error('Invalid banner data. Please check your input.');
            }
            if (error?.response?.status === 403) {
                throw new Error('You don\'t have permission to add banners.');
            }
            throw new Error('Failed to add banner. Please try again.');
        }
    }

    static updateBanner = async (bannerId: string, banner: UpdateBannerRequest) => {
        try {
            return await HttpService.patch(`/store/banners/${bannerId}`, banner);
        } catch (error: any) {
            console.error('Error updating banner:', error);
            if (error?.response?.status === 404) {
                throw new Error('Banner not found. It may have been deleted.');
            }
            if (error?.response?.status === 400) {
                throw new Error('Invalid banner data. Please check your input.');
            }
            if (error?.response?.status === 403) {
                throw new Error('You don\'t have permission to modify this banner.');
            }
            throw new Error('Failed to update banner. Please try again.');
        }
    }

    static deleteBanner = async (bannerId: string) => {
        try {
            return await HttpService.delete(`/store/banners/${bannerId}`);
        } catch (error: any) {
            console.error('Error deleting banner:', error);
            if (error?.response?.status === 404) {
                throw new Error('Banner not found. It may have been deleted.');
            }
            if (error?.response?.status === 403) {
                throw new Error('You don\'t have permission to delete this banner.');
            }
            throw new Error('Failed to delete banner. Please try again.');
        }
    }
}